import React from "react";

const BRANDS = [
  { name: "Rolex", logo: "/brands/rolex.png" },
  { name: "Patek Philippe", logo: "/brands/patek-philippe.png" },
  { name: "Audemars Piguet", logo: "/brands/audemars-piguet.svg" },
  { name: "Omega", logo: "/brands/omega.png" },
  { name: "Cartier", logo: "/brands/cartier.png" },
  { name: "Vacheron Constantin", logo: "/brands/vacheron-constantin.svg" },
  { name: "Richard Mille", logo: "/brands/richard-mille.svg" },
  { name: "A. Lange & Söhne", logo: "/brands/a-lange-sohne.png" },
  { name: "IWC", logo: "/brands/iwc.png" },
  { name: "Jaeger-LeCoultre", logo: "/brands/jaeger-lecoultre.png" },
  { name: "Breitling", logo: "/brands/breitling.png" },
  { name: "Tudor", logo: "/brands/tudor.png" },
  { name: "Hublot", logo: "/brands/hublot.png" },
  { name: "TAG Heuer", logo: "/brands/tag-heuer.png" },
];

export default function Marquee() {
  const items = [...BRANDS, ...BRANDS];
  return (
    <section
      data-testid="marquee-brands"
      className="border-y border-[#001226]/10 bg-[#FCFAF6] overflow-hidden py-8 md:py-12"
    >
      <p className="text-center text-[10px] uppercase tracking-[0.3em] md:tracking-[0.4em] text-[#5C6373] mb-6 md:mb-10 px-4">
        Les plus belles maisons horlogères
      </p>
      <div className="flex animate-marquee whitespace-nowrap items-center">
        {items.map((b, i) => (
          <div
            key={`${b.name}-${i}`}
            className="flex items-center justify-center px-8 md:px-14 shrink-0"
            title={b.name}
          >
            <img
              src={b.logo}
              alt={b.name}
              className="h-8 md:h-12 w-auto max-w-[140px] md:max-w-[200px] object-contain opacity-80 hover:opacity-100 transition-opacity"
              loading="lazy"
              draggable={false}
            />
          </div>
        ))}
      </div>
    </section>
  );
}
